import React, { MouseEvent, useEffect, useState } from 'react'
import { Button, Card, Col, Rate, Row, Space, Typography } from 'antd'
import ShowMoreText from 'react-show-more-text'
import { useHistory } from 'react-router-dom'

import ProfileAvatar from '../../../helpers/ProfileAvatar/ProfileAvatar'

import { TExpert } from '../../../../context/types'
import './ExpertItem.less'
import { useAuthContext } from '../../../../context/auth'
import { currentBrand } from '../../../../config'
import CallPrice from '../../../helpers/CallPrice/CallPrice'
import FavoritesButton from '../../../helpers/FavoritesButton/FavoritesButton'
import { toggleFavoriteExpert } from '../../../../context/experts/utils'
import { useChannelContext } from '../../../../context/channel'

const { Text, Link } = Typography

export type TExpertItem = {
	expert: TExpert
	onRequestCall: () => void
}

function ExpertItem({ expert, onRequestCall }: TExpertItem) {
	const { auth } = useAuthContext()
	const history = useHistory()
	const {
		channel: { selectedChannel },
	} = useChannelContext()
	const [isFavorite, setFavorite] = useState<boolean>(expert.isFavorite)

	useEffect(() => {
		setFavorite(expert.isFavorite)
	}, [expert.isFavorite])

	const stopPropagation = (e: MouseEvent<HTMLElement>) => e.stopPropagation()

	const handleViewProfile = (e: MouseEvent<HTMLElement>) => {
		e.stopPropagation()
		e.preventDefault()
		history.push(`/expert/${expert.slug}`)
	}

	const handleRequestCall = (e: MouseEvent<HTMLElement>) => {
		e.stopPropagation()
		onRequestCall()
	}
	const isSameUser = expert?.profile?.user?.id === auth?.user?.id
	const handleFavoritesClick = (e: MouseEvent<HTMLAnchorElement>) => {
		e.stopPropagation()

		toggleFavoriteExpert(expert.id).then(setFavorite)
	}

	return (
		<Card className="experts-card" onClick={handleViewProfile}>
			<Row gutter={[20, 0]}>
				<Col xs={{ span: 0 }} sm={{ span: 4 }}>
					<Space direction="vertical" align="center" style={{ width: '100%' }}>
						<ProfileAvatar
							className="experts-avatar"
							src={expert?.profile?.user?.profile_pic_url}
							size={{ xs: 60, sm: 60, md: 80, lg: 100, xl: 120, xxl: 120 }}
						/>
						<Text style={{ fontSize: 16, fontWeight: 500, display: 'inline-block', textAlign: 'center' }}>
							{expert?.profile?.user?.first_name} {expert?.profile?.user?.last_name}
						</Text>
					</Space>
				</Col>
				<Col style={{ display: 'flex', flexDirection: 'column' }} xs={{ span: 24 }} sm={{ span: 20 }}>
					<div style={{ display: 'flex', justifyContent: 'space-between' }}>
						<Text strong style={{ fontSize: 16, fontWeight: 700, lineHeight: '26px' }}>
							{expert?.title}
						</Text>
						<div
							className="hidden-mobile"
							style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 10 }}
						>
							{currentBrand.showCallPrice && !selectedChannel?.integration_config.hide_call_pricing && (
								<CallPrice payRate={expert.profile.pay_rate} />
							)}
							{!isSameUser && (
								<Button shape="round" type="primary" onClick={handleRequestCall}>
									Request A Call
								</Button>
							)}
							{!!expert?.profile?.user?.expertInfo?.expert_rating && (
								<Rate
									className="expert-rate"
									value={expert?.profile?.user?.expertInfo?.expert_rating}
									disabled
									allowHalf
								/>
							)}
						</div>
					</div>
					<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
						<ProfileAvatar
							className="experts-avatar experts-small-avatar"
							src={expert?.profile?.user?.profile_pic_url}
							size={{ xs: 60, sm: 60, md: 60, lg: 80, xl: 120, xxl: 120 }}
						/>
						<div className="hidden-desktop" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
							{currentBrand.showCallPrice && !selectedChannel?.integration_config.hide_call_pricing && (
								<CallPrice payRate={expert.profile.pay_rate} />
							)}
							{!isSameUser && (
								<Button shape="round" type="primary" onClick={handleRequestCall}>
									Request A Call
								</Button>
							)}
							{!!expert?.profile?.user?.expertInfo?.expert_rating && (
								<Rate
									className="expert-rate"
									value={expert?.profile?.user?.expertInfo?.expert_rating}
									disabled
									allowHalf
								/>
							)}
						</div>
					</div>
					<div onClick={stopPropagation}>
						<ShowMoreText lines={3} more=" Show more" less=" Show less">
							{expert?.body}
						</ShowMoreText>
					</div>
					<Row justify="space-between" style={{ flex: 1, alignItems: 'flex-end', marginTop: 10 }}>
						<Col flex="none">
							<Space size="large" wrap>
								<Link href={`/expert/${expert.slug}`} onClick={handleViewProfile}>
									<b>View Profile</b>
								</Link>

								{!isSameUser && <FavoritesButton isFavorite={isFavorite} onClick={handleFavoritesClick} />}
							</Space>
						</Col>
					</Row>
				</Col>
			</Row>
		</Card>
	)
}

export default ExpertItem
